/*
  Zayma — Estimated Delivery Date (EDD) widget
  Vanilla JS custom element for snippets/zayma-edd-widget.liquid. No libraries.

  Data flow (no credentials ever live in the browser):
    customer pincode
      -> GET {endpoint}?pincode=NNNNNN            (Shopify App Proxy / worker)
        -> backend authenticates with Velocity Shipping
          -> backend returns { serviceable, city, min_days/max_days | estimated_from/estimated_to }
            -> this script renders the date range

  Three levels of estimate, best first:
    1. Real data from the backend (Velocity serviceability + zone).
    2. REGION_DAYS below — offline estimate by pincode prefix, used when the
       backend is unreachable or has no data. Regionally aware, so Coimbatore
       and Delhi differ even with no backend at all.
    3. The flat Fallback minimum/maximum days from Theme settings, used only
       for a pincode no region rule matches.

  Also runs the return / offer rotator when the Return text setting holds more
  than one message separated by ||. One message means no rotation at all.
  ROTATE_MS is how long each message stays on screen — lower it to speed the
  slideshow up, raise it to slow it down.

  Note: instance properties are deliberately namespaced (eddPrefix, not prefix)
  because Element.prefix is a read-only DOM property.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'zayma_edd_v1';
  var PIN_RE = /^[1-9][0-9]{5}$/;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var CACHE_MS = 12 * 60 * 60 * 1000;
  var TIMEOUT_MS = 6000;
  var ROTATE_MS = 2200;

  /*
    Offline regional estimate, dispatched from Tiruppur (641301).
    Values are TOTAL days the shopper sees — Zayma's 1-2 day dispatch is already
    included. Longer prefixes win, so 737 (Sikkim) beats 73 (East India).
    Edit these freely; real Velocity data always takes priority over them.
  */
  var REGION_DAYS = [
    { name: 'Andaman & Nicobar', prefixes: ['744'], days: [8, 12] },
    { name: 'Sikkim', prefixes: ['737'], days: [7, 10] },
    { name: 'Coimbatore belt', prefixes: ['638', '641', '642'], days: [2, 4] },
    { name: 'Tamil Nadu', prefixes: ['60', '61', '62', '63', '64'], days: [3, 5] },
    { name: 'Karnataka', prefixes: ['56', '57', '58', '59'], days: [3, 6] },
    { name: 'Kerala', prefixes: ['67', '68', '69'], days: [3, 6] },
    { name: 'Andhra Pradesh & Telangana', prefixes: ['50', '51', '52', '53'], days: [4, 6] },
    {
      name: 'West & Central India',
      prefixes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49'],
      days: [4, 7],
    },
    {
      name: 'North India',
      prefixes: ['11', '12', '13', '14', '15', '16', '20', '21', '22', '23', '24', '25', '26', '27', '28', '30', '31', '32', '33', '34'],
      days: [5, 8],
    },
    {
      name: 'East India',
      prefixes: ['70', '71', '72', '73', '74', '75', '76', '77', '80', '81', '82', '83', '84', '85'],
      days: [5, 8],
    },
    { name: 'Hill states & North East', prefixes: ['17', '18', '19', '78', '79'], days: [7, 11] },
  ];

  function regionDays(pincode) {
    var pin = String(pincode || '');
    for (var len = 3; len >= 2; len -= 1) {
      var key = pin.slice(0, len);
      for (var i = 0; i < REGION_DAYS.length; i += 1) {
        if (REGION_DAYS[i].prefixes.indexOf(key) !== -1) return REGION_DAYS[i];
      }
    }
    return null;
  }

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStore(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      /* storage blocked - the widget still works, it just will not remember */
    }
  }

  function startOfToday() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function addDays(base, days, skipSundays) {
    var d = new Date(base.getTime());
    var added = 0;
    var guard = 0;
    while (added < days && guard < 400) {
      guard += 1;
      d.setDate(d.getDate() + 1);
      if (skipSundays && d.getDay() === 0) continue;
      added += 1;
    }
    return d;
  }

  function formatDay(d) {
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function formatRange(from, to) {
    if (!to || from.getTime() === to.getTime()) return formatDay(from);
    return formatDay(from) + ' – ' + formatDay(to);
  }

  function parseISO(value) {
    if (typeof value !== 'string') return null;
    var m = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (!m) return null;
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    if (isNaN(d.getTime())) return null;
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function toISO(d) {
    var month = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
  }

  function toInt(value) {
    if (typeof value === 'number' && isFinite(value)) return Math.round(value);
    if (typeof value === 'string' && value.trim() !== '' && !isNaN(Number(value))) return Math.round(Number(value));
    return null;
  }

  function firstInt() {
    for (var i = 0; i < arguments.length; i += 1) {
      var n = toInt(arguments[i]);
      if (n !== null) return n;
    }
    return null;
  }

  function firstDate() {
    for (var i = 0; i < arguments.length; i += 1) {
      var d = parseISO(arguments[i]);
      if (d) return d;
    }
    return null;
  }

  function cleanCity(value) {
    if (typeof value !== 'string') return '';
    return value.replace(/\s+/g, ' ').trim().slice(0, 40);
  }

  class ZaymaEdd extends HTMLElement {
    connectedCallback() {
      if (this.initialised) {
        this.startRotator();
        return;
      }

      this.input = this.querySelector('[data-zedd-input]');
      this.button = this.querySelector('[data-zedd-btn]');
      this.message = this.querySelector('[data-zedd-msg]');
      if (!this.input || !this.button || !this.message) return;

      this.endpoint = this.dataset.endpoint || '/apps/zayma-edd';
      this.eddPrefix = this.dataset.prefix || 'Estimated delivery';
      this.showCity = this.dataset.showCity !== 'false';
      this.skipSundays = this.dataset.excludeSundays !== 'false';

      var min = toInt(this.dataset.fallbackMin);
      var max = toInt(this.dataset.fallbackMax);
      this.fallbackMin = min === null ? 3 : min;
      this.fallbackMax = max === null ? 7 : max;
      if (this.fallbackMax < this.fallbackMin) this.fallbackMax = this.fallbackMin;

      this.busy = false;
      this.onInput = this.onInput.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onPause = this.onPause.bind(this);
      this.onResume = this.onResume.bind(this);

      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKeydown);
      this.button.addEventListener('click', this.onClick);

      this.initialised = true;
      this.startRotator();
      this.restore();
    }

    disconnectedCallback() {
      this.stopRotator();
    }

    /* ---------------- return / offer rotator ---------------- */

    startRotator() {
      if (this.rotateTimer) return;
      this.slides = [].slice.call(this.querySelectorAll('[data-zedd-slide]'));
      if (this.slides.length < 2) return;

      var self = this;
      this.slideIndex = 0;
      this.rotatePaused = false;

      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onResume);

      this.rotateTimer = window.setInterval(function () {
        if (self.rotatePaused || document.hidden) return;
        self.showSlide((self.slideIndex + 1) % self.slides.length);
      }, ROTATE_MS);
    }

    stopRotator() {
      if (this.rotateTimer) {
        window.clearInterval(this.rotateTimer);
        this.rotateTimer = null;
      }
      this.removeEventListener('mouseenter', this.onPause);
      this.removeEventListener('mouseleave', this.onResume);
      this.removeEventListener('focusin', this.onPause);
      this.removeEventListener('focusout', this.onResume);
    }

    showSlide(next) {
      var current = this.slides[this.slideIndex];
      var upcoming = this.slides[next];
      if (!upcoming || upcoming === current) return;
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');
      this.slideIndex = next;
    }

    onPause() {
      this.rotatePaused = true;
    }

    onResume() {
      this.rotatePaused = false;
    }

    /* ---------------- pincode + delivery ---------------- */

    restore() {
      var saved = readStore();
      if (!saved || !PIN_RE.test(String(saved.pincode || ''))) return;
      this.input.value = saved.pincode;
      if (this.isFresh(saved)) {
        this.render(saved);
      } else {
        this.check();
      }
    }

    isFresh(saved) {
      if (!saved || saved.fallback) return false;
      if (!saved.ts || Date.now() - saved.ts > CACHE_MS) return false;
      if (saved.from) {
        var from = parseISO(saved.from);
        if (!from || from < startOfToday()) return false;
      }
      return true;
    }

    onInput() {
      var cleaned = this.input.value.replace(/[^0-9]/g, '').slice(0, 6);
      if (cleaned !== this.input.value) this.input.value = cleaned;
      this.hideMessage();
    }

    onKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.check();
      }
    }

    onClick(event) {
      event.preventDefault();
      this.check();
    }

    check() {
      if (this.busy) return;

      var pincode = (this.input.value || '').trim();
      if (!pincode) {
        this.showMessage('Please enter your pincode.', 'is-error');
        return;
      }
      if (!PIN_RE.test(pincode)) {
        this.showMessage('Enter a valid 6-digit pincode.', 'is-error');
        return;
      }

      var self = this;
      this.busy = true;
      this.button.disabled = true;
      this.showMessage('Checking delivery…', 'is-muted');

      this.request(pincode).then(function (payload) {
        self.busy = false;
        self.button.disabled = false;
        var result = self.normalise(pincode, payload);
        writeStore(result);
        self.render(result);
      });
    }

    request(pincode) {
      if (typeof window.fetch !== 'function') return Promise.resolve(null);

      var url = this.endpoint + (this.endpoint.indexOf('?') === -1 ? '?' : '&') + 'pincode=' + encodeURIComponent(pincode);
      var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timer = null;

      var timeout = new Promise(function (resolve) {
        timer = window.setTimeout(function () {
          if (controller) {
            try {
              controller.abort();
            } catch (error) {
              /* ignore */
            }
          }
          resolve(null);
        }, TIMEOUT_MS);
      });

      var lookup;
      try {
        lookup = window
          .fetch(url, {
            method: 'GET',
            headers: { Accept: 'application/json' },
            signal: controller ? controller.signal : undefined
          })
          .then(function (response) {
            if (!response.ok) return null;
            var type = response.headers.get('content-type') || '';
            if (type.indexOf('json') === -1) return null;
            return response.json();
          })
          .catch(function () {
            return null;
          });
      } catch (error) {
        lookup = Promise.resolve(null);
      }

      return Promise.race([lookup, timeout]).then(function (payload) {
        if (timer) window.clearTimeout(timer);
        return payload;
      });
    }

    normalise(pincode, payload) {
      var result = { pincode: pincode, ts: Date.now(), serviceable: true, city: '', fallback: false };
      var data = null;

      if (payload && typeof payload === 'object') {
        data = payload.data && typeof payload.data === 'object' ? payload.data : payload;
      }

      if (data) {
        if (data.serviceable === false || data.is_serviceable === false || data.available === false) {
          result.serviceable = false;
          return result;
        }

        result.city = cleanCity(data.city || data.city_name || data.district);

        var from = firstDate(data.estimated_from, data.edd_from, data.delivery_from, data.from);
        if (from) {
          var to = firstDate(data.estimated_to, data.edd_to, data.delivery_to, data.to) || from;
          if (to < from) to = from;
          result.from = toISO(from);
          result.to = toISO(to);
          return result;
        }

        var minDays = firstInt(data.min_days, data.min_tat, data.tat_min, data.minimum_days);
        var maxDays = firstInt(data.max_days, data.max_tat, data.tat_max, data.maximum_days);
        if (minDays === null && maxDays !== null) minDays = maxDays;
        if (minDays !== null) {
          if (maxDays === null || maxDays < minDays) maxDays = minDays;
          result.minDays = minDays;
          result.maxDays = maxDays;
          return result;
        }
      }

      /* No usable backend data — fall back to the regional table, then Theme settings. */
      result.fallback = true;
      var region = regionDays(pincode);
      if (region) {
        result.region = region.name;
        result.minDays = region.days[0];
        result.maxDays = region.days[1];
      } else {
        result.minDays = this.fallbackMin;
        result.maxDays = this.fallbackMax;
      }
      return result;
    }

    render(result) {
      if (result.serviceable === false) {
        this.showMessage('Delivery is currently unavailable for this pincode.', 'is-error');
        return;
      }

      var today = startOfToday();
      var from = result.from ? parseISO(result.from) : null;
      var to = result.to ? parseISO(result.to) : null;
      if (from && from < today) from = null;

      if (!from) {
        var minDays = toInt(result.minDays);
        var maxDays = toInt(result.maxDays);
        if (minDays === null) minDays = this.fallbackMin;
        if (maxDays === null) maxDays = this.fallbackMax;
        if (maxDays < minDays) maxDays = minDays;
        from = addDays(today, minDays, this.skipSundays);
        to = addDays(today, maxDays, this.skipSundays);
      }
      if (!to || to < from) to = from;

      var label = this.eddPrefix;
      if (this.showCity && result.city) label += ' in ' + result.city;

      this.message.className = 'zayma-edd__msg';
      this.message.hidden = false;
      this.message.textContent = label + ': ';

      var strong = document.createElement('strong');
      strong.textContent = formatRange(from, to);
      this.message.appendChild(strong);
    }

    showMessage(text, modifier) {
      this.message.className = 'zayma-edd__msg' + (modifier ? ' ' + modifier : '');
      this.message.hidden = false;
      this.message.textContent = text;
    }

    hideMessage() {
      this.message.hidden = true;
      this.message.textContent = '';
    }
  }

  if (window.customElements && !window.customElements.get('zayma-edd')) {
    window.customElements.define('zayma-edd', ZaymaEdd);
  }
})();